module.exports = __webpack_public_path__ + "media/images/sp_header_btn_login-0fda90fb24536b97dde26055b18534b0.png";